import SubMenuItem from './sub-menu-item';

export default SubMenuItem;